import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { from, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-successconfirmmodal',
  templateUrl: './successconfirmmodal.component.html',
  styleUrls: ['./successconfirmmodal.component.scss']
})
export class SuccessConfirmmodalComponent implements OnInit {

  constructor(
    private translateService: TranslateService
  ) { }

  @Input() isButtonShow : boolean = false;
  @Input() buttonText : string = '';
  @Input() buttonEvent: string = '';
  @Input() modalDialogBodyContent = 'bodyContent';
  @Input() modalDialogType = 'BLOCK_TOAST';

  @Output() closeSuccessModalDialogEvent = new EventEmitter<boolean>();
  @Output() handleSuccessModalOnConfirm = new EventEmitter<boolean>();

  ngOnInit(): void {

    const myArray = [1, 2, 3, 4];
    from(myArray).pipe(
      concatMap(item => of(item).pipe(delay(3000)))
    ).subscribe(timedItem => {
      this.closeSuccessModalDialogEvent.emit(true);
    });

  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'close') {
      this.closeSuccessModalDialogEvent.emit(true);
    }
  }

  buttonAction(){
    if(this.buttonEvent === 'close'){
      this.handleSuccessModalOnConfirm.emit(true);
    }
  }

}
